<template>
  <section class="pb-4">
    <cursos />
  </section>
</template>

<script>
import Cursos from './components/modulos/Cursos.vue'

export default {
  components: {
    Cursos,
  },

}

</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
